import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    margin: 0,
  },
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      minWidth: '2rem',
    },
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '24px',
    color: 'rgba(0, 0, 0, 0.54)',
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
    },
  },
  copyIcon: {
    marginLeft: '1.5rem',
    cursor: 'pointer',
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '24px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
    },
    [theme.breakpoints.down('xs')]: {
      marginLeft: '0.75rem',
    },
  },
  linkText: {
    color: 'black',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  statsSection: {
    paddingRight: '0 !important',
    paddingLeft: '0 !important',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    width: '100%',
    borderRadius: 12,
    overflow: 'hidden',
  },
  statsSectionWrapper: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  statsSectionTitle: {
    fontWeight: 700,
    fontSize: '1.125rem',
    lineHeight: 1.3,
    color: '#172024',
    marginBottom: theme.spacing(2),
  },
  statsMetricsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
    gap: theme.spacing(1.5),
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
  statsMetricsGridThreeCol: {
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
  statCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.75),
    padding: theme.spacing(2),
    borderRadius: 12,
    backgroundColor: '#F4F7F9',
    minHeight: 72,
    boxSizing: 'border-box',
  },
  statLabel: {
    fontSize: '0.6875rem',
    fontWeight: 600,
    letterSpacing: '0.06em',
    lineHeight: 1.3,
    textTransform: 'uppercase',
    color: '#6B7C87',
  },
  statValue: {
    fontSize: '1rem',
    fontWeight: 600,
    lineHeight: 1.3,
    color: '#00205B',
    wordBreak: 'break-word',
  },
  statSubtitle: {
    fontSize: '0.8125rem',
    fontWeight: 400,
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
  },
  statLoader: {
    color: '#00205B',
  },
  statsTitle: {
    fontWeight: '500',
    fontSize: '20px',
    margin: '24px 32px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column !important',
      margin: '16px 28px 0',
      fontSize: '12px',
      lineHeight: '31px',
      textTransform: 'uppercase',
    },
  },
  informationContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column !important',
    },
  },
  informationColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    justifySelf: 'start',
    alignItems: 'flex-start',
    paddingRight: '0',
    width: '50%',
    wordBreak: 'break-word',
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
      paddingTop: 0,
      paddingBottom: 0,
      width: '100%',
    },
  },
  informationItem: {
    display: 'flex',
    alignItems: 'center',
  },
  deleteStudent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: theme.spacing(2),
    },
  },
  deleteText: {
    maxWidth: '60%',
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.5,
    color: '#6B7C87',
    textAlign: 'left',
    margin: 0,
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  },
  deleteActionButton: {
    alignSelf: 'flex-start',
    display: 'inline-flex',
    width: 'auto',
    minWidth: 'auto',
    maxWidth: 'none',
    height: 'auto',
    minHeight: 36,
    maxHeight: 'none',
    padding: '6px 16px',
    fontWeight: 600,
    flexShrink: 0,
  },
  sessionHeader: {
    paddingBottom: '3px',
    paddingTop: '1rem',
    fontWeight: '400',
  },
  table: {
    borderCollapse: 'separate',
    borderSpacing: '0px 6px',
  },
  tableContainer: {
    paddingBottom: '25px',
    minHeight: '75%',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'center',
  },
  sessionsTableToolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'nowrap',
    gap: theme.spacing(1.5),
    width: '100%',
    boxSizing: 'border-box',
    padding: theme.spacing(1, 2),
    minHeight: 56,
    borderBottom: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    },
  },
  sessionsTableToolbarControls: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    flex: '0 1 auto',
    minWidth: 0,
    flexWrap: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      flex: '1 1 100%',
    },
  },
  sessionsSegmentControl: {
    width: 'auto !important',
    minWidth: 'auto',
    maxWidth: 'none',
    flex: '0 0 auto',
    alignSelf: 'center',
    '& .MuiToggleButton-root': {
      flex: '1 1 0',
      width: 140,
      minWidth: 140,
      maxWidth: 140,
    },
  },
  sessionsToolbarActions: {
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'center',
    gap: theme.spacing(1.5),
    flexShrink: 0,
    marginLeft: 'auto',
    '& p': {
      margin: 0,
    },
  },
  yearFilter: {
    width: 'auto',
    minWidth: 96,
    flex: '0 0 auto',
    alignSelf: 'center',
    '& .MuiFormControl-root': {
      width: 'auto',
      minWidth: 96,
    },
    '& .MuiInputBase-root': {
      width: 'auto',
      minWidth: 96,
      minHeight: 40,
      height: 40,
      boxSizing: 'border-box',
    },
    '& .MuiOutlinedInput-input': {
      padding: '8px 12px',
      fontSize: '0.875rem',
    },
    '& .MuiSelect-select': {
      paddingRight: 32,
      boxSizing: 'border-box',
    },
  },
  infoCardsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: theme.spacing(3),
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
  sessionsContainer: {
    paddingTop: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(1),
    },
  },
  sessionsList: {
    borderTop: 'none',
  },
  sessionsRow: {
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap',
      alignItems: 'flex-start',
    },
  },
  sessionsTimeColumn: {
    [theme.breakpoints.down('xs')]: {
      flex: '0 0 72px',
      minWidth: 72,
    },
  },
  sessionsTrailingColumn: {
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginLeft: 0,
      marginTop: theme.spacing(1),
      paddingLeft: `calc(72px + ${theme.spacing(1.5)}px + 4px)`,
      justifyContent: 'flex-end',
      boxSizing: 'border-box',
    },
  },
  sessionsEmptyStateContent: {
    padding: theme.spacing(4, 2),
  },
  sessionsEmptyStateActions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(1),
  },
  lessonPacksEmptyState: {
    padding: theme.spacing(8, 4, 4),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(6, 2, 4),
    },
  },
}))
